import { RootState } from 'store';

export const getReportHistory = (state: RootState) => state.reportHistory;
